import CATEGORIES from "../data/categories";

const THEME_COLORS = [
  "magenta",
  "emerald",
  "amber",
  "tangerine",
  "marine",
  "violet",
];

const getRandomPoster = (category) => {
  const posters = CATEGORIES[category]?.posters ?? [];
  const index = Math.floor(Math.random() * posters.length);
  return posters[index];
};

const getRandomTheme = () => {
  const index = Math.floor(Math.random() * THEME_COLORS.length);
  return THEME_COLORS[index];
};

const fetchTitles = async (who, what, where, why) => {
  if (import.meta.env.DEV) {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return await ["Title 1", "Title 2", "Title 3"];
  }

  const response = await fetch("/.netlify/functions/get_titles", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ who, what, where, why }),
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch titles: ${response.status}`);
  }

  return await response.json();
};

export { THEME_COLORS, getRandomPoster, getRandomTheme, fetchTitles };
